var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgYellowInMain1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 172,
    viewBox: "0 0 268 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.65617 81.6702C-2.63807 84.3564 0.045652 102.025 6.0508 109.879C6.18987 110.573 6.35292 111.261 6.51601 111.949C-2.15454 117.053 5.99213 146.525 15.8737 143.292C16.9197 142.963 17.9781 142.679 19.0356 142.298C14.3142 150.684 22.021 174.324 30.7604 171.446C107.481 146.304 184.177 121.168 260.897 96.0259C270.37 92.9024 263.818 67.6366 254.409 64.5974C257.319 63.8175 260.206 63.044 263.129 62.3095C273.415 59.6999 264.821 28.7868 254.407 30.5528C243.174 32.4407 231.991 34.4131 220.833 36.5736C224.21 35.3274 227.587 34.0811 230.988 32.8284C240.877 29.1542 232.227 -2.62179 222.265 1.07173C149.709 27.927 77.1886 54.8214 4.63208 81.6767L4.65617 81.6702Z",
    fill: "#FBB130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgYellowInMain1);
export default __webpack_public_path__ + "static/media/bg_yellow_inMain1.0c0d8f900d7eb5aa59bdd895df9f3caf.svg";
export { ForwardRef as ReactComponent };